export const ALGOLIA_ATTRIBUTED_CLICK_KEY = 'algoliaAttributedClick';
export const ALGOLIA_ATTRIBUTION_TTL_MS = 30 * 60 * 1000;

export type AlgoliaAttributedClick = {
  objectID: string;
  queryID: string;
  timestamp: number;
};

export const getAlgoliaAttributedClick = (): AlgoliaAttributedClick | null => {
  try {
    const attributedClick = sessionStorage.getItem(
      ALGOLIA_ATTRIBUTED_CLICK_KEY,
    );
    if (!attributedClick) return null;

    return JSON.parse(attributedClick) as AlgoliaAttributedClick;
  } catch {
    return null;
  }
};

export const clearAlgoliaAttributedClick = (): void => {
  sessionStorage.removeItem(ALGOLIA_ATTRIBUTED_CLICK_KEY);
};

export const setAlgoliaAttributedClick = ({
  objectID,
  queryID,
}: {
  objectID: string;
  queryID: string;
}): void => {
  sessionStorage.setItem(
    ALGOLIA_ATTRIBUTED_CLICK_KEY,
    JSON.stringify({
      objectID,
      queryID,
      timestamp: Date.now(),
    }),
  );
};

export const isValidAlgoliaAttributedClick = (
  attributedClick: AlgoliaAttributedClick | null,
  objectID: string,
  ttlMs: number = ALGOLIA_ATTRIBUTION_TTL_MS,
): attributedClick is AlgoliaAttributedClick => {
  if (!attributedClick) return false;

  return (
    !!attributedClick.queryID &&
    !!attributedClick.objectID &&
    attributedClick.objectID === objectID &&
    Date.now() - attributedClick.timestamp <= ttlMs
  );
};
